export const getModalId = (state) => state.modal.id
